export const sortSpecifications = (specifications = []) => {
  if (Array.isArray(specifications)) {
    return specifications.sort((a, b) => a.weightDetails - b.weightDetails)
  } else {
    return []
  }
}
